import React from 'react';
import Icon from '../../../components/AppIcon';

const IncidentOverview = ({ incident }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'resolved':
        return 'text-success bg-success/10';
      case 'investigating':
        return 'text-warning bg-warning/10';
      case 'major-outage':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'resolved':
        return 'CheckCircle';
      case 'investigating':
        return 'AlertTriangle';
      case 'major-outage':
        return 'XCircle';
      default:
        return 'Clock';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
        {/* Service Info */}
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Wifi" size={24} className="text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-foreground">{incident?.serviceName}</h1>
              <p className="text-muted-foreground">{incident?.serviceType}</p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Users" size={16} className="text-muted-foreground" />
                <span className="text-sm text-muted-foreground">Total Reports</span>
              </div>
              <p className="text-2xl font-semibold text-foreground">{incident?.totalReports?.toLocaleString()}</p>
            </div>

            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="MapPin" size={16} className="text-muted-foreground" />
                <span className="text-sm text-muted-foreground">Affected Regions</span>
              </div>
              <p className="text-2xl font-semibold text-foreground">{incident?.affectedRegions}</p>
            </div>

            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Clock" size={16} className="text-muted-foreground" />
                <span className="text-sm text-muted-foreground">Duration</span>
              </div>
              <p className="text-2xl font-semibold text-foreground">{incident?.duration}</p>
            </div>

            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="TrendingUp" size={16} className="text-muted-foreground" />
                <span className="text-sm text-muted-foreground">Peak Reports</span>
              </div>
              <p className="text-2xl font-semibold text-foreground">{incident?.peakReports}</p>
            </div>
          </div>
        </div>

        {/* Status Badge */}
        <div className="flex flex-col items-end gap-4">
          <div className={`flex items-center gap-2 px-4 py-2 rounded-full ${getStatusColor(incident?.status)}`}>
            <Icon name={getStatusIcon(incident?.status)} size={16} />
            <span className="font-medium capitalize">{incident?.status?.replace('-', ' ')}</span>
          </div>

          <div className="text-right">
            <p className="text-sm text-muted-foreground">Last Updated</p>
            <p className="font-medium text-foreground">{incident?.lastUpdated}</p>
          </div>
        </div>
      </div>
      {/* Description */}
      <div className="mt-6 pt-6 border-t border-border">
        <h3 className="font-semibold text-foreground mb-2">Incident Description</h3>
        <p className="text-muted-foreground leading-relaxed">{incident?.description}</p>
      </div>
    </div>
  );
};

export default IncidentOverview;